import * as React from "react";
import PropertyDetailBlockNew from "@/components/organisms/PropertyDetailBlock/new";
import PropertyDetailBlockOld from "@/components/organisms/PropertyDetailBlock/old";

import { useTheme } from "@/hooks/useTheme";

type PropertyDetailBlockProps = {
  onNext: () => void;
};

const PropertyDetailBlock = ({ onNext }: PropertyDetailBlockProps) => {
  const { isNewTheme } = useTheme();
  return (
    <React.Fragment>
      {isNewTheme ? <PropertyDetailBlockNew onNext={onNext} /> : <PropertyDetailBlockOld onNext={onNext} />}
    </React.Fragment>
  );
};

export default PropertyDetailBlock;
